import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { faqs, faqImage } from "../mock";
import useBranding from "../hooks/useBranding";
import { brandText } from "../utils/brand";

const FAQ = () => {
  const [ref, inView] = useReveal();
  const [open, setOpen] = useState(0);
  const b = useBranding();

  return (
    <section className="py-20 md:py-28 bg-white overflow-hidden">
      <div ref={ref} className="pp-container grid lg:grid-cols-2 gap-14 items-start">
        {/* Left image + heading */}
        <div className={`pp-reveal ${inView ? "pp-in" : ""}`}>
          <span className="inline-flex items-center gap-2 text-[#06B6D4] font-semibold uppercase tracking-wider text-sm">
            <span className="w-8 h-[2px] bg-[#06B6D4]" /> FAQ
          </span>
          <h2 className="mt-4 text-3xl md:text-[42px] font-extrabold leading-[1.14] text-[#0D1B2A]">
            Frequently Asked <span className="pp-grad-text">Questions</span>
          </h2>
          <div className="mt-8 rounded-3xl overflow-hidden shadow-xl">
            <img src={faqImage} alt="PhotonPE FAQ" className="w-full h-72 object-cover" />
          </div>
        </div>

        {/* Accordion */}
        <div className={`pp-reveal ${inView ? "pp-in" : ""}`} style={{ animationDelay: "0.12s" }}>
          <div className="space-y-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={i}
                  className={`rounded-2xl border transition-colors ${isOpen ? "border-[#0EA5E9] bg-[#f6f9fd]" : "border-slate-200 bg-white"}`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 text-left px-5 py-4"
                  >
                    <span className={`font-semibold text-[15px] ${isOpen ? "text-[#0EA5E9]" : "text-[#0D1B2A]"}`}>{brandText(f.q, b.company_name)}</span>
                    <span className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${isOpen ? "bg-[#06B6D4] text-white" : "bg-[#F0FDFA] text-[#0EA5E9]"}`}>
                      {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                    </span>
                  </button>
                  <div className="grid transition-all duration-300" style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}>
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm text-[#475569] leading-relaxed">{brandText(f.a, b.company_name)}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
